import React, { ReactNode } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { componentSizes } from '@theme/variables'

export const DialogActionsContainer = styled('div')`
  display: flex;
  align-items: center;
  padding: 0 18px 18px 18px;
  justify-content: flex-end;
  width: 100%;

  & :first-child {
    margin-right: 10px;
  }
`
const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: ${(props: { $width?: number }) => `${props.$width ?? 'none'}px`};
  }
`

interface ConfirmPopupProps {
  title: string
  text: string
  isOpen: boolean
  cancelBtnText?: string
  confirmBtnText: string
  onConfirm: () => void
  onCancel: () => void
  onBackdropClick?: () => void
  width?: number
  children?: ReactNode
  confirmDisabled?: boolean
  contentWidth?: number
  id?: string
}

const ConfirmPopup = ({
  title,
  text,
  isOpen,
  confirmBtnText,
  cancelBtnText,
  children,
  width,
  onConfirm,
  onCancel,
  onBackdropClick,
  confirmDisabled,
  contentWidth,
  id,
}: ConfirmPopupProps) => {
  return (
    <StyledDialog data-testid={id} id={id} open={isOpen} onClose={onBackdropClick ?? onCancel} $width={width}>
      <DialogTitle sx={{ padding: componentSizes.smDistance, paddingBottom: '8px' }}>
        <Typography variant="h2">{title}</Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: componentSizes.smDistance, width: contentWidth }}>
        <Typography variant="body1">{text}</Typography>
        {!!children && children}
      </DialogContent>
      <DialogActionsContainer>
        {cancelBtnText && (
          <Button onClick={onCancel} variant="outlined" color="primary">
            {cancelBtnText}
          </Button>
        )}
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus disabled={confirmDisabled}>
          {confirmBtnText}
        </Button>
      </DialogActionsContainer>
    </StyledDialog>
  )
}

export default ConfirmPopup
